import classNames from 'classnames/bind';
import { ReactComponent as VilniusBarbellGymLogo } from './Vilnius_barbell_gym_logo_juodas.svg';
import Image_Platforms_Color from '../../Images/Image_Platforms_Color.jpg';
import styles from './Container.module.scss';

const cn = classNames.bind(styles);

const Container = (): JSX.Element => {

    return (
        <div className={cn('wrapper')}>
            <div className={cn('container-logo')}>
                    <VilniusBarbellGymLogo/>
            </div>
            <div className={cn('container-pictures')}>
                <div className={cn('container-pictures__picture')}>
                    <img src={Image_Platforms_Color} alt="Boxes" />
                </div>
            </div>

            <div className={cn('container-text')}>
               
                    <p>
                    Adresas: Slucko g. 3, Vilnius.
                    </p>
                    <p>
                    Kaina: 40 eur per mėnesį.
                    </p>
                    <p>
                    Dėl narystės rašykite: <a href="mailto:info@vilniusbarbellgym.lt">info@vilniusbarbellgym.lt</a>
                    </p>
            </div>
        </div>
    );
};

export default Container;
